export const DELETED_ICON = "/images/deletedIcon.svg";
